<div class="layout-login">
  <div class="login-logo">
    <img src="assets/image/logo-vatm.png" alt="Logo">
  </div>
  <div class="header">
    <h4>HỆ THỐNG QUẢN TRỊ NGUỒN NHÂN LỰC</h4>
  </div>
  <div class="card">
    <form [formGroup]="loginForm" (ngSubmit)="onSubmit()">
      <div class="p-fluid grid">
        <div class="field col-12">
          <div class="p-inputgroup">
              <span class="p-inputgroup-addon"><i class="pi pi-user"></i></span>
              <input type="text" pInputText placeholder="{{'login.username' | translate}}" [ngClass]="{'p-invalid': submitted && formErrors.username}" formControlName="username" [(ngModel)]="loginModel.username" required>
          </div>
          <app-validation-messages [message]="'login.username' | translate" [formName]="f.username" [submitted]="submitted">
          </app-validation-messages>
      </div>
        <div class="field col-12">
          <div class="p-inputgroup">
            <span class="p-inputgroup-addon"><i class="pi pi-lock"></i></span>
            <input type="Password" pInputText placeholder="{{'login.password' | translate}}" [ngClass]="{'p-invalid': submitted && formErrors.password}" formControlName="password" [(ngModel)]="loginModel.password" required>
          </div>
          <app-validation-messages [message]="'login.password' | translate" [formName]="f.password" [submitted]="submitted">
          </app-validation-messages>
        </div>
        <!-- <div class="field-checkbox col-12">
          <p-checkbox binary="true" formControlName="remember" [(ngModel)]="loginModel.remember" inputId="binary"></p-checkbox>
          <label for="binary">Remember</label>
        </div> -->
      </div>
      <div class="footer">
        <button pButton pRipple type="submit" label="{{'common.label.login' | translate}}" class="p-button-rounded"></button>
      </div>
    </form>
  </div>
</div>
